module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('label', {
    staticClass: "hidden",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.indicatorSelected))]), _vm._v(" "), _c('label', {
    staticClass: "hidden",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.stateSelected))]), _vm._v(" "), _c('div', {
    staticClass: "chart-title"
  }, [_c('div', {
    staticClass: "col-md-12 bg-primary",
    staticStyle: {
      "max-height": "40px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 text-center car_table_header"
  }, [_c('label', {
    staticClass: "table-label"
  }, [_vm._v("\n            " + _vm._s(_vm.indicatorSelected) + "\n            "), _c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("and related indicators (with year of latest values)\n              " + _vm._s(_vm.$store.state.CAR.stateNameLookUpTable[_vm.selectedState]) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chart-stage col-xs-12",
    staticStyle: {
      "overflow-x": "auto",
      "width": "100%"
    },
    attrs: {
      "id": "scrollTable"
    }
  }, [_c('table', {
    staticClass: "my_custom_table",
    attrs: {
      "id": "source_table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "custom_header"
  }, [_c('td'), _vm._v(" "), (_vm.routineCounter > 0) ? _c('td', {
    attrs: {
      "colspan": _vm.routineCounter
    }
  }, [_vm._v("Routine")]) : _vm._e(), _vm._v(" "), (_vm.surveyCounter > 0) ? _c('td', {
    attrs: {
      "colspan": _vm.surveyCounter
    }
  }, [_vm._v("Surveys")]) : _vm._e(), _vm._v(" "), (_vm.estimatesCounter > 0) ? _c('td', {
    attrs: {
      "colspan": _vm.estimatesCounter
    }
  }, [_vm._v("Estimates\n            ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {}, [_c('span', {
    staticClass: "refresh_sources_icon"
  }, [_vm._v("\n                INDICATORS\n                "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Show all sources'),
      expression: "'Show all sources'",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.refreshSources
    }
  }, [_vm._v("refresh")])], 1)]), _vm._v(" "), _vm._l((_vm.dataSourceUncertainty), function(source, index) {
    return _c('td', {
      key: index,
      staticClass: "table_sources",
      attrs: {
        "id": source.name
      },
      on: {
        "click": function($event) {
          _vm.tableSourceClicked(source.name)
        }
      }
    }, [(source.name == 'NHMIS-DHIS2') ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (_vm.sourceFullName[source.name]),
        expression: "sourceFullName[source.name]",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "source_name",
      attrs: {
        "data-step": "4",
        "data-intro": "<b>Select Data Source </b><p>Click on any of these data sources to change the currently visualized data source</p>"
      }
    }, [_vm._v(_vm._s(source.name))]) : (source.name == 'NHMIS-DHIS2 (monthly)') ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (_vm.sourceFullName[source.name]),
        expression: "sourceFullName[source.name]",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "source_name",
      attrs: {
        "data-step": "4",
        "data-intro": "<b>Select Data Source </b><p>Click on any of these data sources to change the currently visualized data source</p>"
      }
    }, [_vm._v("NHMIS-DHIS2"), _c('br'), _vm._v("(monthly)")]) : _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (_vm.sourceFullName[source.name]),
        expression: "sourceFullName[source.name]",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "source_name"
    }, [_vm._v(_vm._s(source.name))]), _vm._v(" "), (source.name == 'NHMIS-DHIS2 (monthly)') ? _c('svg', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see source definition'),
        expression: "'Click to see source definition'",
        modifiers: {
          "right": true
        }
      }],
      staticStyle: {
        "width": "13px",
        "height": "13px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.viewSourceMetadata('NHMIS')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })]) : _c('svg', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see source definition'),
        expression: "'Click to see source definition'",
        modifiers: {
          "right": true
        }
      }],
      staticStyle: {
        "width": "13px",
        "height": "13px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.viewSourceMetadata(source.name)
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })]), _vm._v(" "), (_vm.isUncertaintyAvailable[source.name] === true) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: ('See confidence range'),
        expression: "'See confidence range'",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "web-features",
      staticStyle: {
        "top": "0"
      }
    }, [_c('b-switch', {
      attrs: {
        "type": "is-success"
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.plotUncertainty(source.uncertainty, source.name, index)
        }
      },
      model: {
        value: (source.uncertainty),
        callback: function($$v) {
          _vm.$set(source, "uncertainty", $$v)
        },
        expression: "source.uncertainty"
      }
    })], 1) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.indicatorRelativeValuese), function(indicator, count) {
    return _c('tr', {
      key: count + Math.random(),
      staticStyle: {
        "max-height": "80px"
      }
    }, [_c('td', {
      staticStyle: {
        "word-wrap": "break-word",
        "text-align": "left",
        "cursor": "default"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count !== 1 && count !== 0),
        expression: "count !== 1 && count !== 0"
      }]
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see metadata definition'),
        expression: "'Click to see metadata definition'",
        modifiers: {
          "right": true
        }
      }],
      staticClass: "table_info_icon",
      staticStyle: {
        "background": "#41918e",
        "margin-right": "4px"
      },
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#FFF",
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "table-multiselect"
    }, [_c('multi-select', {
      ref: 'relative' + count - 1,
      refInFor: true,
      attrs: {
        "data-step": "5",
        "data-intro": "<b>Change Related Indicator</b><p>Click here to select your preferred related indicator from the drop-down menu</p>",
        "options": _vm.optionIndicators,
        "group-values": "indicators",
        "group-label": "programArea",
        "group-collapsible": _vm.collapsible,
        "group-select": false,
        "group-collapsible-expanded": false,
        "allow-empty": false,
        "show-labels": false,
        "placeholder": _vm.multiselectPlaceholderM(count - 1),
        "track-by": "name",
        "label": "name"
      },
      on: {
        "open": _vm.openedMultiselect,
        "search-change": _vm.multiselectSearch,
        "close": function($event) {
          _vm.closedMultiselect(indicator[0][0], count - 1)
        }
      },
      model: {
        value: (_vm.selectIndicatorRelative[count - 1]),
        callback: function($$v) {
          _vm.$set(_vm.selectIndicatorRelative, count - 1, $$v)
        },
        expression: "selectIndicatorRelative[count - 1]"
      }
    }, [_c('span', {
      attrs: {
        "slot": "noResult"
      },
      slot: "noResult"
    }, [_vm._v("\n                        Oops! No elements found. Change the search query.\n                      ")])])], 1)]), _vm._v(" "), _c('span', {
      staticClass: "display-factor",
      staticStyle: {
        "color": "black"
      },
      domProps: {
        "innerHTML": _vm._s('(' + _vm.displayFactor[count] + ')')
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count === 1),
        expression: "count === 1"
      }]
    }, [_vm._v(_vm._s(indicator[0][0]))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count === 0),
        expression: "count === 0"
      }]
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see metadata definition'),
        expression: "'Click to see metadata definition'",
        modifiers: {
          "right": true
        }
      }],
      staticClass: "table_info_icon1",
      staticStyle: {
        "background": "#fff",
        "margin-right": "8px"
      },
      attrs: {
        "data-v-step": "2"
      },
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#41918E",
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })])]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_vm._v(_vm._s(indicator[0][0]))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "display-factor",
      staticStyle: {
        "color": "white"
      },
      domProps: {
        "innerHTML": _vm._s('(' + _vm.displayFactor[count] + ')')
      }
    })])]), _vm._v(" "), _vm._l((indicator[1]), function(item, counter) {
      return _c('td', {
        key: counter,
        domProps: {
          "innerHTML": _vm._s(item)
        }
      })
    })], 2)
  }), _vm._v(" "), (_vm.showToggle) ? _c('tr', {
    attrs: {
      "id": "nhmis-hidden-bar"
    }
  }, [_c('td', {
    staticStyle: {
      "background-color": "#367574",
      "margin-bottom": "#367574",
      "max-height": "45px"
    },
    attrs: {
      "colspan": _vm.spanning + 2
    }
  }, [_c('div', {
    staticClass: "row numden"
  }, [_c('div', {
    staticClass: "numden1"
  }, [_c('div', {
    staticClass: "py-2",
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold",
      "letter-spacing": "0",
      "font-size": "14px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.ndSelected) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "numden2 py-2 border",
    staticStyle: {
      "background-color": "#fff",
      "border-radius": "4px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-6 col-sm-6 mr-3 text-wrap"
  }, [_c('strong', [_vm._v("Numerator")]), _vm._v(" : " + _vm._s(_vm.numerator) + ":\n                    " + _vm._s(_vm.thousandSeperator(_vm.numValue)) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-5 col-sm-5 ml-3 text-wrap"
  }, [_c('strong', [_vm._v("Denominator")]), _vm._v(" : " + _vm._s(_vm.denominator) + ":\n                    " + _vm._s(_vm.thousandSeperator(_vm.denValue)) + "\n                  ")])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.indicatorRelativeValues), function(indicator, count) {
    return _c('tr', {
      key: count
    }, [_c('td', {
      staticStyle: {
        "word-wrap": "break-word",
        "text-align": "left",
        "cursor": "default"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count == 1 || count == 2),
        expression: "count == 1 || count == 2"
      }]
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see metadata definition'),
        expression: "'Click to see metadata definition'",
        modifiers: {
          "right": true
        }
      }],
      staticClass: "table_info_icon",
      staticStyle: {
        "background": "#41918e",
        "margin-right": "4px"
      },
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#FFF",
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "table-multiselect"
    }, [_c('multi-select', {
      ref: 'relative' + count,
      refInFor: true,
      attrs: {
        "data-step": "5",
        "data-intro": "<b>Change Related Indicator</b><p>Click here to select your preferred related indicator from the drop-down menu</p>",
        "options": _vm.optionIndicators,
        "group-values": "indicators",
        "group-label": "programArea",
        "group-collapsible": _vm.collapsible,
        "group-select": false,
        "group-collapsible-expanded": false,
        "allow-empty": false,
        "show-labels": false,
        "placeholder": _vm.multiselectPlaceholderM(count - 1),
        "track-by": "name",
        "label": "name"
      },
      on: {
        "open": _vm.openedMultiselect,
        "search-change": _vm.multiselectSearch,
        "close": function($event) {
          _vm.closedMultiselect(indicator[0][0], count - 1)
        }
      },
      model: {
        value: (_vm.selectIndicatorRelative[count - 1]),
        callback: function($$v) {
          _vm.$set(_vm.selectIndicatorRelative, count - 1, $$v)
        },
        expression: "selectIndicatorRelative[count - 1]"
      }
    }, [_c('span', {
      attrs: {
        "slot": "noResult"
      },
      slot: "noResult"
    }, [_vm._v("\n                        Oops! No elements found. Change the search query.\n                      ")])])], 1)]), _vm._v(" "), _c('span', {
      staticClass: "display-factor",
      staticStyle: {
        "color": "black"
      },
      domProps: {
        "innerHTML": _vm._s('(' + _vm.displayFactor[count + 1] + ')')
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count === 0),
        expression: "count === 0"
      }]
    }, [_vm._v(_vm._s(indicator[0][0]))])]), _vm._v(" "), _vm._l((indicator[1]), function(item, counter) {
      return _c('td', {
        key: counter,
        domProps: {
          "innerHTML": _vm._s(item)
        }
      })
    })], 2)
  })], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_c('b', [_vm._v("INDICATOR: ")]), _vm._v(" " + _vm._s(this.indicatorMetaDataToShow) + "\n            ")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "tabs is-boxed is-right"
  }, [_c('ul', _vm._l((_vm.availableSources), function(i) {
    return _c('li', {
      key: i,
      class: {
        'is-active': i == _vm.isActive
      },
      attrs: {
        "value": i
      },
      on: {
        "click": function($event) {
          _vm.dataSourceClicked(i)
        }
      }
    }, [_c('a', [_c('span', [_vm._v(_vm._s(i))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("INDICATOR NAME")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("INDICATOR SHORT NAME")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceIndicatorInfo.shortName))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("INDICATOR DEFINITION")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceIndicatorInfo.definition))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("MEASUREMENT")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("Numerator: ")]), _c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.numerator))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("Denominator: ")]), _c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.denominator))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("MULTIPLIER FACTOR")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.multiplier))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("FREQUENCY")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.frequency))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("TYPE OF INDICATOR")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceIndicatorInfo.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Level of Data Available")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v("National\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.National
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Geopolitical Zone\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.Zonal
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("State Level\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.State
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Senatorial Zone\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.Senatorial
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Local Govt Area\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.LGA
    }
  }, [_vm._v("check_circle")])], 1)])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = false
      }
    }
  }, [_vm._v("\n              CLOSE\n            ")])])])])])], 1), _vm._v(" "), (_vm.isSourceMetaModalActive) ? _c('div', [_c('table-modal', {
    attrs: {
      "src": _vm.datasingle,
      "sourceMetaData": _vm.datafull
    },
    on: {
      "switchOff": _vm.clearModal
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-976f9cb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/mainCar/tableComponent.vue
// module id = 976
// module chunks = 0